import { render, staticRenderFns } from "./UserSettingsMenu.vue?vue&type=template&id=268a7141&"
import script from "./UserSettingsMenu.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports